import { Helmet } from 'react-helmet-async';
import { TopBarLanding } from '../../components/TopBars/TopBarLanding';
import './Landing.css';
import ww_screenshot_landing from '../../assets/images/wwscreenshot.png';
import start_making_bets from '../../assets/landing/start_making_bets.svg';
import becomeasportsbettingwizard from '../../assets/landing/become_a_sports_betting_wizard.svg';
// import wwscreenshot2 from '../../assets/landing/ww_screenshot2.svg';
import whatouruserssay from '../../assets/landing/what_our_users_say.svg';
import letsgetyouwinning from '../../assets/landing/letsgetyouwinning.svg';
import testimonial_image from '../../assets/landing/testimonial_image.svg';
import { Footer } from '../../components/Footer/Footer';
import { SignUp } from './SignUp/SignUp';
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import YouTubeEmbed from './YoutubeEmbed';
import { VimeoEmbed } from './VideoEmbed';
import wagerwizlogo_desktop from '../../assets/WagerWiz_OnDark_Vector.svg';
import { ProfitCalculator } from '../../components/ProfitCalculator';
import React from 'react';
import { SPORTSBOOKS } from '../../utils/constants';
import { LogoGenerator } from '../../components/LogoGenerator';

export const Landing = (props) => {
	const { login } = props;
	const [isSigningUp, setIsSigningUp] = useState(false);

	const [width, setWidth] = useState(window.innerWidth);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 750);
	const { loginWithRedirect } = useAuth0();
	useEffect(() => {
		const handleResize = () => {
			setWidth(window.innerWidth);
			if (window.innerWidth >= 750) {
				setIsMobile(false);
			} else {
				setIsMobile(true);
			}
		};
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		const hash = window.location.hash;
		if (hash) {
			const element = document.querySelector(hash);
			if (element) {
				element.scrollIntoView({ behavior: 'smooth' });
			}
		}
	});

	const scrollToRegion = () => {
		const hash = window.location.hash;
		if (hash) {
			const element = document.querySelector(hash);
			if (element) {

				element.scrollIntoView({ behavior: 'smooth' });
			}
		}
	};

	// Add FeaturesList component below ProfitCalculator
	const FeaturesList = () => {
		// Responsive: detect mobile
		const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 750);
		React.useEffect(() => {
			const handleResize = () => setIsMobile(window.innerWidth <= 750);
			window.addEventListener('resize', handleResize);
			return () => window.removeEventListener('resize', handleResize);
		}, []);

		return (
			<div
				style={{
					display: 'flex',
					flexDirection: isMobile ? 'column' : 'row',
					alignItems: isMobile ? 'center' : 'flex-start',
					justifyContent: isMobile ? 'center' : 'space-between',
					gap: isMobile ? 24 : 24,
					margin: isMobile ? '8px auto 16px auto' : '0 auto',
					marginTop: isMobile ? 8 : 48,
					marginBottom: isMobile ? 16 : 48,
					maxWidth: isMobile ? 320 : 1400,
					width: '100%',
					background: isMobile ? '#191b1f' : '#181a1f',
					border: '1.5px solid #23272f',
					borderRadius: 18,
					boxShadow: isMobile ? '0 2px 8px #0002' : '0 4px 16px #0002',
					padding: isMobile ? 10 : 32,
				}}
			>
				{/* Feature 1 */}
				<div style={{ 
					display: 'flex', 
					flexDirection: 'column', 
					alignItems: 'center', 
					textAlign: 'center', 
					flex: isMobile ? 'none' : 1,
					padding: isMobile ? 0 : '0 12px',
					minWidth: 0
				}}>
					{/* Bell Icon */}
					<div style={{ background: '#23272f', borderRadius: 12, padding: isMobile ? 8 : 16, marginBottom: isMobile ? 6 : 12 }}>
						<svg width={isMobile ? 24 : 36} height={isMobile ? 24 : 36} viewBox="0 0 24 24" fill="none"><path d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2zm6-6V11c0-3.07-1.63-5.64-4.5-6.32V4a1.5 1.5 0 0 0-3 0v.68C7.63 5.36 6 7.92 6 11v5l-1.29 1.29A1 1 0 0 0 6 19h12a1 1 0 0 0 .71-1.71L18 16z" fill="#3b82f6"/></svg>
					</div>
					<div style={{ 
						fontWeight: 600, 
						fontSize: isMobile ? 15 : 20, 
						marginBottom: isMobile ? 3 : 8,
						color: 'white',
						lineHeight: 1.3
					}}>Receive play notifications</div>
					<div style={{ 
						color: '#bdbdbd', 
						fontSize: isMobile ? 12 : 15, 
						textAlign: 'center',
						lineHeight: 1.5,
						maxWidth: isMobile ? 260 : '100%',
						padding: isMobile ? 0 : '0 8px'
					}}>
						Get instant alerts when new profitable plays are available, so you never miss an opportunity.
					</div>
				</div>
				{/* Feature 2 */}
				<div style={{ 
					display: 'flex', 
					flexDirection: 'column', 
					alignItems: 'center', 
					textAlign: 'center', 
					flex: isMobile ? 'none' : 1,
					padding: isMobile ? 0 : '0 12px',
					minWidth: 0
				}}>
					{/* List/Check Icon */}
					<div style={{ background: '#23272f', borderRadius: 12, padding: isMobile ? 8 : 16, marginBottom: isMobile ? 6 : 12 }}>
						<svg width={isMobile ? 24 : 36} height={isMobile ? 24 : 36} viewBox="0 0 24 24" fill="none"><path d="M4 6h16M4 12h16M4 18h7" stroke="rgb(189, 189, 189)" strokeWidth="2.2" strokeLinecap="round"/></svg>
					</div>
					<div style={{ 
						fontWeight: 600, 
						fontSize: isMobile ? 15 : 20, 
						marginBottom: isMobile ? 3 : 8,
						color: 'white',
						lineHeight: 1.3
					}}>Keep track of placed bets</div>
					<div style={{ 
						color: '#bdbdbd', 
						fontSize: isMobile ? 12 : 15, 
						textAlign: 'center',
						lineHeight: 1.5,
						maxWidth: isMobile ? 260 : '100%',
						padding: isMobile ? 0 : '0 8px'
					}}>
						Easily monitor your bet history and stay organized with a clear record of all your wagers.
					</div>
				</div>
				{/* Feature 3 */}
				<div style={{ 
					display: 'flex', 
					flexDirection: 'column', 
					alignItems: 'center', 
					textAlign: 'center', 
					flex: isMobile ? 'none' : 1,
					padding: isMobile ? 0 : '0 12px',
					minWidth: 0
				}}>
					{/* Refresh Icon */}
					<div style={{ background: '#23272f', borderRadius: 12, padding: isMobile ? 8 : 16, marginBottom: isMobile ? 6 : 12 }}>
						<svg width={isMobile ? 24 : 36} height={isMobile ? 24 : 36} viewBox="0 0 24 24" fill="none"><path d="M17.65 6.35A7.95 7.95 0 0 0 12 4V1l-4 4 4 4V6c3.31 0 6 2.69 6 6 0 1.3-.42 2.5-1.13 3.47l1.46 1.46A7.932 7.932 0 0 0 20 12c0-2.21-.9-4.21-2.35-5.65zM6.35 17.65A7.95 7.95 0 0 0 12 20v3l4-4-4-4v3c-3.31 0-6-2.69-6-6 0-1.3.42-2.5 1.13-3.47l-1.46-1.46A7.932 7.932 0 0 0 4 12c0 2.21.9 4.21 2.35 5.65z" fill="#10b981"/></svg>
					</div>
					<div style={{ 
						fontWeight: 600, 
						fontSize: isMobile ? 15 : 20, 
						marginBottom: isMobile ? 3 : 8,
						color: 'white',
						lineHeight: 1.3
					}}>Auto-refresh odds</div>
					<div style={{ 
						color: '#bdbdbd', 
						fontSize: isMobile ? 12 : 15, 
						textAlign: 'center',
						lineHeight: 1.5,
						maxWidth: isMobile ? 260 : '100%',
						padding: isMobile ? 0 : '0 8px'
					}}>
						Odds and plays update automatically, so you always have the latest information at your fingertips.
					</div>
				</div>
			</div>
		);
	};

	// AnimatedSportsbooks component
	const AnimatedSportsbooks = () => {
		const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 750);
		React.useEffect(() => {
			const handleResize = () => setIsMobile(window.innerWidth <= 750);
			window.addEventListener('resize', handleResize);
			return () => window.removeEventListener('resize', handleResize);
		}, []);

		// Split sportsbooks into 3 rows
		const books = SPORTSBOOKS.map(b => b.value);
		const rowCount = 3;
		const rows = Array.from({ length: rowCount }, (_, i) => books.filter((_, idx) => idx % rowCount === i));

		// Animation offsets for each row
		const [offsets, setOffsets] = React.useState([0, 0, 0]);
		const rowRefs = [React.useRef(), React.useRef(), React.useRef()];
		const containerRefs = [React.useRef(), React.useRef(), React.useRef()];
		const [repeatCounts, setRepeatCounts] = React.useState([3, 3, 3]);

		// Dynamically determine how many times to repeat the logos for seamless scroll
		React.useEffect(() => {
			function updateRepeats() {
				setRepeatCounts(rows.map((row, i) => {
					const container = containerRefs[i].current;
					const rowEl = rowRefs[i].current;
					if (!container || !rowEl) return 3;
					const containerWidth = container.offsetWidth;
					const singleRowWidth = rowEl.scrollWidth / repeatCounts[i];
					// Repeat enough times to cover at least 2x the container width
					return Math.max(3, Math.ceil((containerWidth * 2) / singleRowWidth));
				}));
			}
			updateRepeats();
			window.addEventListener('resize', updateRepeats);
			return () => window.removeEventListener('resize', updateRepeats);
			// eslint-disable-next-line
		}, [isMobile]);

		React.useEffect(() => {
			let running = true;
			let last = performance.now();
			const speeds = [0.5, -0.7, 0.5]; // px per frame, middle row is negative for left

			function animate(now) {
				if (!running) return;
				const dt = now - last;
				last = now;
				setOffsets(prev => prev.map((offset, i) => {
					const row = rowRefs[i].current;
					const container = containerRefs[i].current;
					if (!row || !container) return offset;
					const singleRowWidth = row.scrollWidth / repeatCounts[i];
					const totalWidth = row.scrollWidth;
					let next = offset + speeds[i] * (dt / 16.67); // normalize to 60fps
					// For leftward scroll
					if (speeds[i] < 0 && Math.abs(next) > singleRowWidth) next += singleRowWidth;
					// For rightward scroll
					if (speeds[i] > 0 && next > 0) next -= singleRowWidth;
					return next;
				}));
				requestAnimationFrame(animate);
			}
			requestAnimationFrame(animate);
			return () => { running = false; };
		}, [repeatCounts]);

		return (
			<div style={{
				background: '#23262F',
				borderRadius: 18,
				margin: isMobile ? '16px' : '32px auto',
				padding: isMobile ? '18px 0 8px 0' : '32px 0 16px 0',
				boxShadow: '0 2px 16px #0002',
				width: '100%',
				maxWidth: 1400,
				marginLeft: 'auto',
				marginRight: 'auto',
				overflow: 'hidden',
			}}>
				<div style={{
					textAlign: 'center',
					color: 'white',
					fontWeight: 600,
					fontSize: isMobile ? 16 : 28,
					letterSpacing: 1,
					marginBottom: isMobile ? 12 : 24,
					marginTop: isMobile ? 0 : 8,
				}}>
					OVER <span style={{ color: '#fbbf24' }}>100</span> OF THE WORLD'S BEST SPORTSBOOKS INCLUDING INTERNATIONAL AND CRYPTO BOOKS.
				</div>
				<div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? 10 : 18 }}>
					{rows.map((row, i) => (
						<div
							key={i}
							ref={containerRefs[i]}
							style={{
								width: '100%',
								overflow: 'hidden',
								position: 'relative',
								height: isMobile ? 38 : 60,
								margin: '0 auto',
								display: 'flex',
								alignItems: 'center',
							}}
						>
							<div
								ref={rowRefs[i]}
								style={{
									display: 'inline-flex',
									alignItems: 'center',
									gap: isMobile ? 18 : 32,
									minWidth: `${repeatCounts[i] * 100}%`,
									whiteSpace: 'nowrap',
									transform: `translateX(${offsets[i]}px)`
								}}
							>
								{Array(repeatCounts[i]).fill(row).flat().map((book, idx) => (
									<LogoGenerator key={book + idx} sportsbook={book} isMobile={isMobile} smallLogos={isMobile} />
								))}
							</div>
						</div>
					))}
				</div>
			</div>
		);
	};

	return (
		<div style={{ height: '100vh' }}>
			<Helmet>
				<title>WagerWiz | Positive EV, Arbitrage & Odds Screener for Sports Bettors</title>
				<meta name="description" content="Find positive-EV bets, arbitrage opportunities, and the best sportsbook odds across 20+ books. WagerWiz is the data-driven toolkit for serious sports bettors." />
				<link rel="canonical" href="https://www.thewagerwiz.com/" />
				<meta property="og:title" content="WagerWiz | Positive EV, Arbitrage & Odds Screener" />
				<meta property="og:description" content="Find positive-EV bets, arbitrage opportunities, and the best sportsbook odds across 20+ books with WagerWiz." />
				<meta property="og:type" content="website" />
				<meta property="og:url" content="https://www.thewagerwiz.com/" />
				<meta property="og:site_name" content="WagerWiz" />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content="WagerWiz | Positive EV, Arbitrage & Odds Screener" />
				<meta name="twitter:description" content="Find positive-EV bets, arbitrage opportunities, and the best sportsbook odds across 20+ books with WagerWiz." />
				<script type="application/ld+json">{JSON.stringify({
					'@context': 'https://schema.org',
					'@type': 'Organization',
					name: 'WagerWiz',
					url: 'https://www.thewagerwiz.com',
					logo: 'https://www.thewagerwiz.com/wwlogo2.svg',
					sameAs: [],
				})}</script>
				<script type="application/ld+json">{JSON.stringify({
					'@context': 'https://schema.org',
					'@type': 'WebSite',
					name: 'WagerWiz',
					url: 'https://www.thewagerwiz.com',
				})}</script>
			</Helmet>
			<TopBarLanding login={login} setIsSigningUp={setIsSigningUp} isSigningUp={isSigningUp} scrollToRegion={scrollToRegion} />
			{isSigningUp && <SignUp login={login} />}
			{/* <img src={backgroundhero}/> */}

			{!isSigningUp && (
				<div className="landing">
					<div className="flex text-3xl flex-col text-white">
						{
							isMobile && <img className='mt-4' style={{marginLeft: "auto", marginRight: 'auto'}} src={wagerwizlogo_desktop} alt="wager wiz logo" height={225} width={225} />
						}
						<div
							style={{
								border: '1px solid white',
								borderRadius: '10px',
								width: 'fit-content',
								padding: '8px',
								fontSize: '17px',
								marginLeft: 'auto',
								marginRight: 'auto',
								marginTop: '30px',
							}}>
							✨ Loved by <bold>200 + sports bettors</bold> worldwide
						</div>
						{/* <div style={{ fontSize: '48px', fontWeight: 'bold', textAlign: 'center', marginTop: '30px', lineHeight: '60px' }}>
						Become a sports
						<br />
						betting wizard
					</div> */}
						<div className="mt-10 mb-10" style={{ alignSelf: 'center' }}>
							<img width={isMobile ? 300 : ''} src={becomeasportsbettingwizard} alt="become a sports betting wizard" />
						</div>
						{/* <div onClick={login}>Sign in with Google 🚀 </div> */}
						<div
							style={{
								textAlign: 'center',
								width: '700px',
								alignSelf: 'center',
								lineHeight: '40px',
								fontSize: isMobile ? 20 : '',
								maxWidth: isMobile ? width * 0.9 : '',
							}}>
							Quickly spot profitable plays, track your bets, and grow your bankroll - all in one place. Our tools make it easier than ever to beat the sportsbooks.
						</div>
						{/* Buttons below description */}
						<div
							style={{
								display: 'flex',
								flexDirection: isMobile ? 'column' : 'row',
								justifyContent: 'center',
								alignItems: 'center',
								gap: isMobile ? 12 : 24,
								marginTop: 28,
							}}
						>
						<a
							href="/ev-scanner"
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								justifyContent: 'center',
								background: '#7c3aed',
								color: 'white',
								border: 'none',
								borderRadius: 20,
								padding: 0,
								fontSize: 20,
								fontWeight: 600,
								cursor: 'pointer',
								width: 280,
								height: 56,
								marginBottom: isMobile ? 10 : 0,
								boxShadow: '0 4px 14px rgba(124, 58, 237, 0.35)',
								transition: 'background 0.2s, box-shadow 0.2s',
								textDecoration: 'none',
							}}
							onMouseOver={e => {
								e.currentTarget.style.background = '#6d28d9';
								e.currentTarget.style.boxShadow = '0 6px 20px rgba(124, 58, 237, 0.45)';
							}}
							onMouseOut={e => {
								e.currentTarget.style.background = '#7c3aed';
								e.currentTarget.style.boxShadow = '0 4px 14px rgba(124, 58, 237, 0.35)';
							}}
						>
							Try Free EV Scanner
						</a>
						<a
							href="/screener"
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								justifyContent: 'center',
								background: '#10b981',
								color: 'white',
								border: 'none',
								borderRadius: 20,
								padding: 0,
								fontSize: 20,
								fontWeight: 600,
								cursor: 'pointer',
								width: 280,
								height: 56,
								marginBottom: isMobile ? 10 : 0,
								boxShadow: '0 4px 14px rgba(16, 185, 129, 0.35)',
								transition: 'background 0.2s, box-shadow 0.2s',
								textDecoration: 'none',
							}}
							onMouseOver={e => {
								e.currentTarget.style.background = '#059669';
								e.currentTarget.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.45)';
							}}
							onMouseOut={e => {
								e.currentTarget.style.background = '#10b981';
								e.currentTarget.style.boxShadow = '0 4px 14px rgba(16, 185, 129, 0.35)';
							}}
						>
							Try Free Odds Screener
						</a>
							<a
								href="/pricing"
								style={{
									display: 'inline-flex',
									alignItems: 'center',
									justifyContent: 'center',
									background: '#2563ff',
									color: 'white',
									border: 'none',
									borderRadius: 20,
									padding: 0,
									fontSize: 20,
									fontWeight: 500,
									cursor: 'pointer',
									width: 200,
									height: 56,
									marginBottom: isMobile ? 10 : 0,
									boxShadow: 'none',
									transition: 'background 0.2s',
									textDecoration: 'none',
								}}
								onMouseOver={e => (e.currentTarget.style.background = '#1d4ed8')}
								onMouseOut={e => (e.currentTarget.style.background = '#2563ff')}
							>
								Sign Up
							</a>
							<a
								href="/pricing"
								style={{
									display: 'inline-flex',
									alignItems: 'center',
									justifyContent: 'center',
									background: 'transparent',
									color: 'white',
									border: '2px solid #e5e7eb',
									borderRadius: 20,
									padding: 0,
									fontSize: 20,
									fontWeight: 500,
									cursor: 'pointer',
									width: 200,
									height: 56,
									marginLeft: isMobile ? 0 : 0,
									boxShadow: 'none',
									transition: 'border 0.2s, color 0.2s',
									textDecoration: 'none',
									boxSizing: 'border-box',
								}}
								onMouseOver={e => {
									e.currentTarget.style.border = '2px solid #fff';
									e.currentTarget.style.color = '#fff';
								}}
								onMouseOut={e => {
									e.currentTarget.style.border = '2px solid #e5e7eb';
									e.currentTarget.style.color = 'white';
								}}
							>
								See Plans
							</a>
						</div>
						<div className={`mt-8 ${isMobile ? 'p-3' : 'p-8'}`} style={{ alignSelf: 'center', display: 'flex', justifyContent: 'center', width: '100%' }}>
							<img style={{borderRadius: 16, width: isMobile ? '100%' : '95%', maxWidth: isMobile ? '100%' : 1400, height: 'auto', display: 'block'}} src={ww_screenshot_landing} alt="screenshot" />
						</div>

						{/* Block 2 - Find Betting Edges */}
						<div style={{ 
							width: isMobile ? 'calc(100% - 32px)' : '95%', 
							maxWidth: 1400,
							margin: '0 auto',
							padding: isMobile ? '24px 16px' : '40px 32px',
							background: 'linear-gradient(135deg, #1a1d23 0%, #23272f 100%)',
							border: '1px solid #2d3748',
							borderRadius: 24,
							boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
							marginTop: isMobile ? 32 : 48,
							marginBottom: isMobile ? 32 : 48,
							marginLeft: isMobile ? 16 : 'auto',
							marginRight: isMobile ? 16 : 'auto'
						}}>
							<div style={{ 
								display: 'flex', 
								flexDirection: isMobile ? 'column' : 'row', 
								alignItems: 'center',
								gap: isMobile ? 24 : 48
							}}>
								{!isMobile && (
									<div style={{ flex: '0 0 50%' }}>
										<img 
											src={require('../../assets/landing/ww_screenshot2.svg').default} 
											alt="Find Betting Edges - EV Page Screenshot" 
											style={{ 
												width: '100%', 
												borderRadius: 16, 
												boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)' 
											}} 
										/>
									</div>
								)}
								<div style={{ 
									flex: 1, 
									color: 'white',
									textAlign: isMobile ? 'center' : 'left'
								}}>
									<h2 style={{ 
										fontSize: isMobile ? 28 : 36, 
										fontWeight: 700, 
										marginBottom: 16, 
										color: '#3b82f6',
										lineHeight: 1.2,
										letterSpacing: '-0.02em'
									}}>
										Find Betting Edges
									</h2>
									<p style={{ 
										fontSize: isMobile ? 16 : 18, 
										color: '#94a3b8', 
										marginBottom: 24, 
										lineHeight: 1.6,
										fontWeight: 400
									}}>
										Spot profitable opportunities with our EV analysis. Filter by sports, check edge percentages, and visualize odds movement to find the best plays.
									</p>
									<div style={{ 
										display: 'grid', 
										gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', 
										gap: 12,
										marginTop: 24
									}}>
										{[
											{ icon: '🎯', title: 'Smart Filters', desc: 'Focus on your favorite sports and books' },
											{ icon: '📊', title: 'EV Analysis', desc: 'See the exact edge for each play' },
											{ icon: '📈', title: 'Line History', desc: 'Visualize odds movement over time' },
											{ icon: '⚡', title: 'Quick Betting', desc: 'One-click links to place bets' }
										].map((feature, index) => (
											<div key={index} style={{
												display: 'flex',
												alignItems: 'center',
												gap: 10,
												padding: '12px 14px',
												background: 'rgba(59, 130, 246, 0.03)',
												border: '1px solid rgba(59, 130, 246, 0.08)',
												borderRadius: 10,
												transition: 'all 0.2s ease',
												backdropFilter: 'blur(10px)'
											}}>
												<div style={{ fontSize: 16, flexShrink: 0, opacity: 0.9 }}>{feature.icon}</div>
												<div style={{ minWidth: 0 }}>
													<div style={{ 
														fontWeight: 600, 
														fontSize: 13, 
														color: 'white', 
														marginBottom: 2,
														letterSpacing: '-0.01em'
													}}>
														{feature.title}
													</div>
													<div style={{ 
														fontSize: 12, 
														color: '#94a3b8', 
														lineHeight: 1.3,
														opacity: 0.9
													}}>
														{feature.desc}
													</div>
												</div>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>

						{/* Block 3 - Guarantee profit with arbitrage bets */}
						<div style={{ 
							width: isMobile ? 'calc(100% - 32px)' : '95%', 
							maxWidth: 1400,
							margin: '0 auto',
							padding: isMobile ? '24px 16px' : '32px 28px',
							background: isMobile 
								? 'linear-gradient(135deg, #1a1d23 0%, #23272f 100%)'
								: 'radial-gradient(ellipse at center, rgba(26, 29, 35, 0.4) 0%, rgba(26, 29, 35, 0.8) 50%, #1a1d23 100%), linear-gradient(135deg, #1a1d23 0%, #23272f 100%)',
							border: '1px solid #2d3748',
							borderRadius: 24,
							boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
							marginTop: isMobile ? 32 : 48,
							marginBottom: isMobile ? 32 : 48,
							marginLeft: isMobile ? 16 : 'auto',
							marginRight: isMobile ? 16 : 'auto'
						}}>
							{isMobile ? (
								<div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
									<img 
										src={require('../../assets/landing/arbitrage_mobile_card.png')} 
										alt="Arbitrage Mobile Card Screenshot" 
										style={{ 
											width: '100%', 
											height: 'auto',
											maxHeight: 500,
											objectFit: 'contain',
											borderRadius: 12
										}} 
									/>
									<div style={{ color: 'white', textAlign: 'center' }}>
										<h2 style={{ 
											fontSize: 28, 
											fontWeight: 700, 
											marginBottom: 12, 
											color: '#10b981',
											lineHeight: 1.2,
											letterSpacing: '-0.02em'
										}}>
											Guarantee profit with arbitrage bets
										</h2>
										<p style={{ 
											fontSize: 16, 
											color: '#94a3b8', 
											marginBottom: 20, 
											lineHeight: 1.5,
											fontWeight: 400
										}}>
											Lock in guaranteed profits by betting both sides at different sportsbooks. When odds align perfectly, you win regardless of the outcome.
										</p>
										<div style={{ 
											display: 'grid', 
											gridTemplateColumns: '1fr', 
											gap: 10,
											marginTop: 20
										}}>
											{[
												{ icon: '💰', title: 'Guaranteed Profit', desc: 'Win every time, no matter the outcome' },
												{ icon: '📱', title: 'Mobile Ready', desc: 'Find and place bets on the go' },
												{ icon: '🛡️', title: 'Risk-Free', desc: 'Zero risk with guaranteed returns' },
												{ icon: '⚡', title: 'Easy Setup', desc: 'See exactly how much to stake' }
											].map((feature, index) => (
												<div key={index} style={{
													display: 'flex',
													alignItems: 'center',
													gap: 8,
													padding: '10px 12px',
													background: 'rgba(16, 185, 129, 0.03)',
													border: '1px solid rgba(16, 185, 129, 0.08)',
													borderRadius: 8,
													transition: 'all 0.2s ease'
												}}>
													<div style={{ fontSize: 13, flexShrink: 0 }}>{feature.icon}</div>
													<div style={{ minWidth: 0 }}>
														<div style={{ 
															fontWeight: 600, 
															fontSize: 13, 
															color: '#ffffff', 
															marginBottom: 2,
															letterSpacing: '-0.01em'
														}}>
															{feature.title}
														</div>
														<div style={{ 
															fontSize: 12, 
															color: '#b0b8c4', 
															lineHeight: 1.3
														}}>
															{feature.desc}
														</div>
													</div>
												</div>
											))}
										</div>
									</div>
								</div>
							) : (
								<div style={{ 
									display: 'grid', 
									gridTemplateColumns: 'repeat(12, 1fr)', 
									gap: 24,
									alignItems: 'center'
								}}>
									{/* Bet Card - 5 columns */}
									<div style={{ 
										gridColumn: 'span 5',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center'
									}}>
										<img 
											src={require('../../assets/landing/arbitrage_mobile_card.png')} 
											alt="Arbitrage Mobile Card Screenshot" 
											style={{ 
												width: '100%', 
												height: 'auto',
												maxHeight: 450,
												objectFit: 'contain',
												borderRadius: 12
											}} 
										/>
									</div>
									{/* Content - 7 columns */}
									<div style={{ 
										gridColumn: 'span 7',
										color: 'white',
										textAlign: 'left'
									}}>
										<h2 style={{ 
											fontSize: 31, 
											fontWeight: 700, 
											marginBottom: 12, 
											color: '#10b981',
											lineHeight: 1.2,
											letterSpacing: '-0.02em',
											maxWidth: '100%',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
											display: '-webkit-box',
											WebkitLineClamp: 2,
											WebkitBoxOrient: 'vertical'
										}}>
											Guarantee profit with arbitrage bets
										</h2>
										<p style={{ 
											fontSize: 16, 
											color: '#94a3b8', 
											marginBottom: 16, 
											lineHeight: 1.5,
											fontWeight: 400
										}}>
											Lock in guaranteed profits by betting both sides at different sportsbooks. When odds align perfectly, you win regardless of the outcome.
										</p>
										{/* Feature cards in 2x2 grid */}
										<div style={{ 
											display: 'grid', 
											gridTemplateColumns: 'repeat(2, 1fr)', 
											gap: 10,
											marginTop: 0
										}}>
											{[
												{ icon: '💰', title: 'Guaranteed Profit', desc: 'Win every time, no matter the outcome' },
												{ icon: '📱', title: 'Mobile Ready', desc: 'Find and place bets on the go' },
												{ icon: '🛡️', title: 'Risk-Free', desc: 'Zero risk with guaranteed returns' },
												{ icon: '⚡', title: 'Easy Setup', desc: 'See exactly how much to stake' }
											].map((feature, index) => (
												<div key={index} style={{
													display: 'flex',
													alignItems: 'center',
													gap: 8,
													padding: '8px 10px',
													background: 'rgba(16, 185, 129, 0.03)',
													border: '1px solid rgba(16, 185, 129, 0.08)',
													borderRadius: 8,
													transition: 'all 0.2s ease'
												}}>
													<div style={{ fontSize: 13, flexShrink: 0 }}>{feature.icon}</div>
													<div style={{ minWidth: 0 }}>
														<div style={{ 
															fontWeight: 600, 
															fontSize: 12, 
															color: '#ffffff', 
															marginBottom: 2,
															letterSpacing: '-0.01em'
														}}>
															{feature.title}
														</div>
														<div style={{ 
															fontSize: 11, 
															color: '#b0b8c4', 
															lineHeight: 1.3
														}}>
															{feature.desc}
														</div>
													</div>
												</div>
											))}
										</div>
									</div>
								</div>
							)}
						</div>

						{/* Profit Calculator Section */}
						<div style={{ width: isMobile ? '95%' : '95%', maxWidth: 1400, margin: isMobile ? '40px' : '48px auto 0 auto', marginRight: isMobile ? 10 : 'auto', marginLeft: isMobile ? 10 : 'auto' }}>
							<ProfitCalculator />
							<FeaturesList />
							<AnimatedSportsbooks />
						</div>

						<div className="mt-10 p-5" style={{ alignSelf: 'center', maxWidth: isMobile ? width * 0.9 : '' }}>
							<img src={start_making_bets} alt="start making bets" />
						</div>
						{/* <div style={{ width: '70%', alignSelf: 'center' }}> */}
							{/* <YouTubeEmbed /> */}
							{/* <VimeoEmbed videoId="1075849944?h=717c54798f" /> */}
						{/* </div> */}
						<div id="features" style={{ alignSelf: 'center', maxWidth: isMobile ? '95%' : '1600px', width: '100%', display: 'flex', flexDirection: "column", justifyContent: 'center', alignItems: "center", marginTop: isMobile ? 32 : 48, marginBottom: isMobile ? 0 : 0, padding: 0 }}>
							<h2 style={{ fontSize: isMobile ? 32 : 48, fontWeight: 700, color: 'white', marginBottom: isMobile ? 8 : 12, textAlign: 'center' }}>What our users say</h2>
							<p style={{ fontSize: isMobile ? 14 : 16, color: '#94a3b8', marginBottom: isMobile ? 20 : 32, textAlign: 'center', maxWidth: 600 }}>See what members of our community are saying about WagerWiz.</p>
							<div style={{ width: '100%', maxWidth: 1600, margin: '0 auto' }}>
								<img style={{ width: '100%', height: 'auto', display: 'block' }} src={testimonial_image} alt="testimonials" />
							</div>
						</div>
						{!isMobile && (
							<div 
								style={{ 
									alignSelf: 'center', 
									marginTop: '-100px',
									marginBottom: 80,
									width: '100%',
									maxWidth: 800,
									background: 'radial-gradient(ellipse at center, rgba(26, 29, 35, 0.6) 0%, rgba(24, 26, 31, 0.3) 60%, transparent 100%), linear-gradient(135deg, #1a1d23 0%, #23272f 100%)',
									border: '1px solid #2d3748',
									borderRadius: 24,
									padding: '40px 32px',
									textAlign: 'center',
									boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									gap: 20
								}}
							>
								<img 
									src={wagerwizlogo_desktop} 
									alt="WagerWiz logo" 
									style={{ 
										height: 60,
										width: 'auto',
										display: 'block'
									}} 
								/>
								<h2 style={{ 
									fontSize: 36, 
									fontWeight: 700, 
									color: 'white', 
									margin: 0,
									lineHeight: 1.2,
									maxWidth: 720
								}}>
									Let's get you winning today.
								</h2>
								<p style={{ 
									fontSize: 16, 
									color: '#94a3b8', 
									margin: 0,
									lineHeight: 1.6,
									maxWidth: 600
								}}>
									Bet with the sharp money and move the odds back in your favor.
								</p>
								<button 
									onClick={() =>
										loginWithRedirect({
											authorizationParams: {
												prompt: 'login select_account',
											},
										})
									}
									style={{
										background: '#2563ff',
										color: 'white',
										border: 'none',
										borderRadius: 12,
										padding: '16px 32px',
										fontSize: 18,
										fontWeight: 600,
										cursor: 'pointer',
										transition: 'background 0.2s',
										marginTop: 4
									}}
									onMouseEnter={(e) => e.currentTarget.style.background = '#1d4ed8'}
									onMouseLeave={(e) => e.currentTarget.style.background = '#2563ff'}
								>
									Create a free account
								</button>
							</div>
						)}

						<div className="">
							<Footer />
						</div>
					</div>
				</div>
			)}
		</div>
	);
};
